<dx-data-grid
  #gridArticoliConsegnati
  [dataSource]="dataSource"
  [showBorders]="true"
  [focusedRowEnabled]="false"
  [focusedRowIndex]="0"
  [columnAutoWidth]="true"
  [showColumnLines]="true"
  [showRowLines]="true"
  [columnHidingEnabled]="false"
  (onRowPrepared)="onRowPrepared()"
  (onRowDblClick)="goToDipDashboard($event.data)">


  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
  <dxo-filter-row [visible]="false"></dxo-filter-row>

  <dxo-editing
    mode="row"
    [allowAdding]="false"
    [allowUpdating]="false"
    [allowDeleting] ="false"
    [useIcons]="false">
    <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>

  </dxo-editing>

  <dxi-column
    dataField="idDipendente"
    caption="DIPENDENTE" [visible]="(idArticolo>0) || (idArticolo==0 && idDipendente==0) || (idArticolo==undefined && idDipendente==undefined)">
    <dxo-lookup [dataSource]="listDipendenti" valueExpr="id" displayExpr="nominativo" ></dxo-lookup>
  </dxi-column>

  <dxi-column
    dataField="idArticolo"
    caption="ARTICOLO" [visible]="idDipendente>0 || (idArticolo==0 && idDipendente==0) || (idArticolo==undefined && idDipendente==undefined)">
    <dxo-lookup [dataSource]="listArticoli" valueExpr="id" displayExpr="descrizione" ></dxo-lookup>
  </dxi-column>

  <dxi-column
    dataField="dataScadenza"
    caption="DATA SCADENZA"
    format="dd/MM/yyyy"
    dataType="date">
  </dxi-column>

  <dxi-column
    caption="STATO"
    [allowSorting]="false"
    [allowFiltering]="false"
    cellTemplate="statoConsegna">
  </dxi-column>

  <div *dxTemplate="let d of 'statoConsegna'">
    @if (isScaduto(d.data.dataScadenza)) {
      <span class="badge text-white bg-danger" style="font-size:12px">Scaduto</span>
    }

    @if (!isScaduto(d.data.dataScadenza) && isInScadenza(d.data.dataScadenza)) {
      <span class="badge text-dark bg-warning" style="font-size:12px">In scadenza</span>
    }
  </div>

</dx-data-grid>